import { render } from "./Heading.vue?vue&type=template&id=62115bfd&scoped=true"
import script from "./Heading.vue?vue&type=script&lang=js"
export * from "./Heading.vue?vue&type=script&lang=js"

import "./Heading.vue?vue&type=style&index=0&id=62115bfd&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-62115bfd"

export default script